import {getSessionManagementServiceInstance,} from '../../omnibox/services/SessionManagementService';

export namespace CollectionUtils {
  export const checkCollectionSiteSetting: () => (boolean) = () => {
    return getSessionManagementServiceInstance().isCollectionsEnabledOnSite();
  };
}